import React, { useState } from "react";
import { coverageAsOptions, getSelectedCoverage } from "./coverages.helpers";

import Select from "@storeblocks/select";
import { WrapLgMarginBottom } from "App/global-style";
import { ProductBackendName } from "Components/Features/CheckPrice/Products/productTypes";
import { Data } from "Components/TextContext/textInterfaces";
import { InsuranceCoverage } from "Store/interfaces/products/coverage";
import { TextLanguage } from "Store/texts/interfaces";
import { FormikProps } from "formik";
import { CoverageCard } from "./CoverageCard";
import { CoveragePriceCalculation } from "./coverages.types";

interface Props {
  product: ProductBackendName;
  defaultCoverage: InsuranceCoverage;
  fieldName: string;
  priceFilterValue?: string;
  formProps: FormikProps<any>;
  groupedCoveragePrices: CoveragePriceCalculation[];
  groupedCoverageText: any;
  lang: TextLanguage;
  shortTermProduct?: boolean;
  hideRadioButton?: boolean;
  disabled?: boolean;
  showExcludedCoverages?: boolean;
  priceIsLoading?: boolean;
  textComponents: Data[];
}

export const GroupedCoverageCard = ({
  product,
  priceFilterValue,
  formProps,
  defaultCoverage,
  groupedCoveragePrices,
  groupedCoverageText,
  shortTermProduct,
  hideRadioButton = false,
  disabled = false,
  lang,
  fieldName,
  showExcludedCoverages,
  priceIsLoading,
  textComponents,
}: Props): React.ReactElement | null => {
  const groupedCoverages = groupedCoveragePrices.map(([coverage]) => coverage);
  const formCoverage = formProps.values[fieldName];
  const initialCoverage = groupedCoverages.includes(formCoverage)
    ? formCoverage
    : defaultCoverage;
  const [selectedCoverage, setSelectedCoverage] = useState(initialCoverage);
  const selectedGroupedCoverage = getSelectedCoverage(
    selectedCoverage,
    groupedCoveragePrices,
  );
  if (!selectedGroupedCoverage) {
    return null;
  }

  const updateSelectedCoverage = ({
    target: { value },
  }: React.ChangeEvent<HTMLSelectElement>): void => {
    setSelectedCoverage(value as InsuranceCoverage);
    const selected = groupedCoverages.includes(formCoverage);
    if (selected) {
      formProps.setFieldValue(fieldName, value as InsuranceCoverage);
    }
  };

  return (
    <CoverageCard
      fieldName={fieldName}
      product={product}
      coverage={selectedCoverage}
      textComponents={textComponents}
      prices={selectedGroupedCoverage[1].prices}
      priceFilterValue={priceFilterValue}
      shortTermProduct={shortTermProduct}
      hideRadioButton={hideRadioButton}
      disabled={disabled}
      showExcludedCoverages={showExcludedCoverages}
      priceIsLoading={priceIsLoading}
    >
      <WrapLgMarginBottom>
        <Select
          id="groupedCoverage"
          name="groupedCoverage"
          large
          label={groupedCoverageText.label[lang]}
          hint={groupedCoverageText.hint[lang]}
          options={coverageAsOptions(
            groupedCoverages,
            groupedCoverageText,
            lang,
          )}
          value={selectedCoverage}
          onChange={updateSelectedCoverage}
        />
      </WrapLgMarginBottom>
    </CoverageCard>
  );
};
